// extracted by mini-css-extract-plugin
export default {"card":"Scheduled_card__MZHfI","head":"Scheduled_head__cX1bO","title":"Scheduled_title__JNNo2","form":"Scheduled_form__6nXDy","sorting":"Scheduled_sorting__5JTDA"};